module.exports = __webpack_public_path__ + "img/C05TechEquesChampion_ua.a1b48782.webp";